<template>
  <tr @dblclick="$refs['actions'].callFirstStarredAction();"
    class="d-block d-lg-table-row bg-white px-2 py-2 mb-2 border p-lg-0 mb-lg-0 border-lg-0">
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Id') }}</span>
      <FieldReadonly :value="profile.id" />
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Name') }}</span>
      <FieldReadonly :value="profile.name" />
    </td>
    <td data-no-export class="d-block d-lg-table-cell text-end border-0 border-lg-bottom" @click.stop>
      <ActionDropdown ref="actions" :actions="actions" />
    </td>
  </tr>
</template>

<script>
import api from "@/api.js";
import FieldReadonly from "@/components/common/form/FieldReadonly.vue";
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";

export default {
  components: {
    FieldReadonly,
    ActionDropdown,
  },
  props: {
    application: {
      type: Object,
      required: true,
    },
    profile: Object,
  },
  data() {
    return {};
  },
  emits: [
    'edit',
    'duplicate',
    'deleted',
    'updating',
    'updated',
  ],
  methods: {
  },
  computed: {
    actions() {
      return [{
        label: this.i18n('Edit'),
        fn: () => {
          this.$emit('edit', this.profile);
        },
        if: (this.profile.acl?.update) === true,
        starred: true,
      }, {
        label: this.i18n('Duplicate'),
        fn: () => {
          this.$emit('duplicate', this.profile);
        },
        if: (this.profile.acl?.duplicate) === true,
        starred: true,
      },
      {
        label: this.i18n('Detail'),
        fn: () => {
          this.$emit('edit', this.profile);
        },
        if: (this.profile.acl?.update) !== true,
        starred: true,
      },
      {
        label: this.i18n('Delete'),
        fn: () => {
          this.$emit('updating', this.profile);
          this.$root.requestConfirmation(this.i18n('Delete? This action cannot be undone.'), () => {
            api.delete(`applications/${this.application.id}/profiles/${this.profile.id}`).then(() => {
              this.$emit('deleted', this.profile);
              api.clearCache();
            }).then(() => {
              // Force reload
              this.$emit('updated', this.profile);
            });
          });
        },
        if: (this.profile.acl?.delete) === true,
        starred: false,
      },
      ];
    },
  },
};
</script>